import url from 'url'
import querystring from 'querystring'
import * as moment from 'moment'

export const ImageFormat = {
  imageView: function (hash, w, h, mode, format) {
    mode = mode || 1
    let url = ''
    if (!hash) return false
    if (!hash.match(/^(http|https):/i)) {
      url = varConfig.qiniuCdn + '/' + hash
    } else {
      url = hash
    }
    if (url.match(/qiniucdn\.com/i) || /live.banmabang.cn/.test(url) ||
        url.match(/images\.banmabang\.cn/i) || url.match(/images\.snsports\.cn/i)) {
      if (url.indexOf('?') < 0) {
        url = url + '?imageView2/' + mode + '/w/' + w + '/h/' + h
        if (format) {
          url += '/format/' + format
          if (format === 'jpg') {
            url += '/interlace/1'
          }
        }
      }
    }
    return url
  },
  squareImageView: function(hash, size, mode, format) {
    return this.imageView(hash, size, size, mode, format)
  }
}

export const ConstConfig = {
  apiPath: '/api/content/phone',
  authApiPath: '/api_passport',
  wxApiPath: '/api',
  client_id: '101448529',
  wxAppId: 'wx83d351356eb8c592'
  // qiniuUpload: 'http://upload.qiniu.com'
}

export let varConfig = {
  qiniuCdn: process.env.QINIU_CDN,
  banmaApi: process.env.BANMA_API,
  siteUrl: process.env.SITE_URL,
  cbApi: process.env.CB_API,
  camApi: process.env.CAM_API,
  payUrl: process.env.PAYURL,
  qiniuUpload: 'http://upload.qiniup.com'
}

if (enableHttps()) {
  varConfig.qiniuCdn = replaceHttps(varConfig.qiniuCdn)
  varConfig.banmaApi = replaceHttps(varConfig.banmaApi)
  varConfig.siteUrl = replaceHttps(varConfig.siteUrl)
  varConfig.cbApi = replaceHttps(varConfig.cbApi)
  varConfig.camApi = replaceHttps(varConfig.camApi)
  varConfig.payUrl = replaceHttps(varConfig.payUrl)
  varConfig.qiniuUpload = replaceHttps(varConfig.qiniuUpload)
}

function replaceHttps(url) {
  return url.replace('http:', 'https:')
}

export const AppType = {
  isInWeChat: function() { // 判断是否是在微信内打开
    return /MicroMessenger/i.test(window.navigator.userAgent)
  },
  isInQQ: function() { // 判断是否是在微信内打开
    return /QQ/i.test(window.navigator.userAgent) && /mobile/i.test(window.navigator.userAgent)
  },
  isInApp: function() { // 包含bmb and bmLive
    return /Banma/i.test(window.navigator.userAgent)
  },
  isInBmApp: function() {
    return /Banma/i.test(window.navigator.userAgent) && !(/BanmaLive/i.test(window.navigator.userAgent))
  },
  isInLiveApp: function() {
    return /BanmaLive/i.test(window.navigator.userAgent)
  },
  isInBmBktApp: function() {
    return /Banmabk/i.test(window.navigator.userAgent)
  },
  // isInAndroid: function() {
  //   return /Android/i.test(window.navigator.userAgent)
  // },
  isInAndroid: function () { // android终端
    var u = navigator.userAgent
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  },
  isInIOS: function () { // ios终端
    var u = navigator.userAgent
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  }
}

function enableHttps() {
  return window.location.protocol === 'https:'
}

export function getSearchParams (absUrl) {
  absUrl = absUrl || window.location.href
  let query = url.parse(absUrl).hash
  if (query) {
    query = query.replace(/^#[ -~]+\?/, '')
  }
  return querystring.parse(query)
}

export function formatDate(date, type) {
  if (type && type === 'datetime') {
    return moment(date).format('YYYY.MM.DD HH:mm:ss')
  } else {
    return moment(date).format('YYYY.MM.DD')
  }
}

export function getSearchQueryParams(url) {
  // This function is anonymous, is executed immediately and
  // the return value is assigned to QueryString!
  url = url || window.location.href
  var queryString = ''
  if (url) {
    var urlParts = url.split('?')
    if (urlParts.length === 3) { // Url中可能有两个问号，hash中也可能有问号，这种情况，将两部分参数拼在一起处理。
      queryString = urlParts[1].replace(/#.*/, '') + '&' + urlParts[2]
    } else if (urlParts.length === 2) {
      queryString = urlParts[1]
    }
  } else {
    queryString = uriParse().search
  }

  var getQueryString = {}
  var vars = queryString.split('&')
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) continue
    var pair = vars[i].split('=')
    // If first entry with this name
    if (typeof getQueryString[pair[0]] === 'undefined') {
      getQueryString[pair[0]] = decodeURIComponent(pair[1])
      // If second entry with this name
    } else if (typeof getQueryString[pair[0]] === 'string') {
      getQueryString[pair[0]] = [getQueryString[pair[0]], decodeURIComponent(pair[1])]
      // If third or later entry with this name
    } else {
      getQueryString[pair[0]].push(decodeURIComponent(pair[1]))
    }
  }
  return getQueryString
}

function uriParse(uri) {
  uri = uri || window.location.href
  var location = {
    absUrl: window.location.href,
    referUrl: document.referrer,
    domain: window.location.hostname,
    protocol: window.location.protocol,
    port: window.location.port,
    path: window.location.pathname,
    search: window.location.search ? window.location.search.substring(1) : '',
    hash: window.location.hash,
    title: document.getElementsByTagName('title')[0].innerHTML,
    userAgent: navigator.userAgent
  }
  return location
}

// 获取应用的渠道
export function getSourceType () {
  let ret = 'h5'
  if (AppType.isInBmApp()) {
    ret = 'bmb'
  } else if (AppType.isInLiveApp()) {
    ret = 'bmblive'
  } else if (AppType.isInBmBktApp()) {
    ret = 'bkt'
  }
  return ret
}

export function getAppPath (name) {
  let path = `${name}-stage`
  if (process.env.ENV === 'prod') {
    path = name
  } else if (process.env.ENV === 'pre') {
    path = `${name}-pre`
  }
  return path
}



// WEBPACK FOOTER //
// ./src/utils/index.js